export const DEBUG: boolean = process.env.NODE_ENV === "development";
export const API_HOST = DEBUG
    // ? "http://0.0.0.0:5000/"
    // ? "http://101.37.160.234/"
    ? "https://zhrccp-api.cecctm.com/"
    : "https://zhrccp-api.cecctm.com/";
export const TOKEN_KEY: string = "GXHB_PARTNER_TOKEN_zzxxcc";
export const CHANNEL_CACHE: string = "GXHB_PARTNER_CHANNEL_CACHE_zzxxcc";

export const OSS_CONFIG = {
    accessKeyId: "LTAILd5c2RRGOvd2",
    accessKeySecret: "81JmSiMQ37kt9fwubs1Tzok5JSCAJt",
    bucket: "cecctm",
    region: "oss-cn-hangzhou",
    "user-bucket-url": "//cecctm.oss-cn-hangzhou.aliyuncs.com/",
}

export enum EnumAppStatus {
    Pending,
    Success,
    Error,
}

export enum EnumChannels {
    CIDA = "cida",
    DZSWS = "dzsws",
    XMTYYS = "xmtyys",
    SQYYS = "sqyys",
    WLGLS = "wlgls",
    SJFXS = "sjfxs",
    WLYXS = "wlyxs",
}

export const CHANNELS_CONFIG: { label: string, value: string }[] = [
    { label: "室内设计师", value: EnumChannels.CIDA },
    { label: "电子商务师", value: EnumChannels.DZSWS },
    { label: "新媒体运营师", value: EnumChannels.XMTYYS },
    { label: "社群运营师", value: EnumChannels.SQYYS },
    { label: "物流管理师", value: EnumChannels.WLGLS },
    { label: "数据分析师", value: EnumChannels.SJFXS },
    { label: "网络营销师", value: EnumChannels.WLYXS },
];

export const CHANNELS: string[] = CHANNELS_CONFIG.map(_ => _.value);


export enum EnumGender {
    MALE = 0,
    FEMALE = 1,
}

export const GenderType = [
    { label: "男", value: EnumGender.MALE },
    { label: "女", value: EnumGender.FEMALE },
];

export enum EnumPapersType {
    Mainland = 1,
    Taiwan = 2,
    Passport = 3,
}

export const PapersTypes = [
    { label: "大陆居民身份证", value: EnumPapersType.Mainland },
    { label: "台湾居民身份证", value: EnumPapersType.Taiwan },
    { label: "护照", value: EnumPapersType.Passport },
];

export enum EnumCreateBy {
    USER = 1,
    PARTNER = 2,
}

export const Degree = ['研究生', '本科', '大专', '其他'];


export const certExportTitle = [
    { title: "姓名", key: 'name', col: { wch: 20 } },
    { title: "性别", key: 'gender', col: { wch: 10 } },
    { title: "身份证号", key: 'idNumber', col: { wch: 20 } },
    { title: "联系方式", key: 'phoneNumber', col: { wch: 15 } },
    { title: "报考科目", key: 'productName', col: { wch: 20 } },
    { title: "考试时间", key: 'examTime', col: { wch: 20 } },
    { title: "缴费信息", key: 'payInfo', col: { wch: 30 } },
    { title: "状态", key: 'status', col: { wch: 10 } },
    { title: "报名时间", key: 'createTime', col: { wch: 20 } },
];

export const CertRecordsExportConfig = [
    { title: "姓名", key: 'name', col: { wch: 10 } },
    { title: "身份证号", key: 'idNumber', col: { wch: 24 } },
    { title: "性别", key: 'gender', col: { wch: 10 } },
    { title: "民族", key: 'racial', col: { wch: 10 } },
    { title: "联系方式", key: 'phoneNumber', col: { wch: 14 } },
    { title: "电子邮箱", key: 'email', col: { wch: 14 } },
    { title: "地址信息", key: 'address', col: { wch: 50 } },
    { title: "教育信息", key: 'graduate', col: { wch: 50 } },
    { title: "工作信息", key: 'work', col: { wch: 50 } },
    { title: "考试科目", key: 'project', col: { wch: 40 } },
    { title: "考试时间", key: 'examTime', col: { wch: 40 } },
    { title: "缴费金额", key: 'payAmount', col: { wch: 40 } },
    { title: "缴费时间", key: 'payTime', col: { wch: 40 } },
    { title: "状态", key: 'status', col: { wch: 40 } },
    { title: "证书编号", key: 'certNo', col: { wch: 20 } },
    { title: "颁发日期", key: 'issueDate', col: { wch: 20 } },
    { title: "邀请人", key: 'inviter', col: { wch: 20 } },
];
